const CartConstants = {
    ADD_PRODUCT_TO_CART: 'ADD_PRODUCT_TO_CART',
    REMOVE_PRODUCT_FROM_CART: 'REMOVE_PRODUCT_FROM_CART',
    EDIT_PRODUCT_IN_CART: 'EDIT_PRODUCT_IN_CART',
    CLEAR_CART: 'CLEAR_CART',
    ADD_PRODUCT: 'ADD_PRODUCT',
    EDIT_PRODUCT: 'EDIT_PRODUCT',
    REMOVE_PRODUCT: 'REMOVE_PRODUCT',
    FETCH_PRODUCTS_SUCCESS: 'FETCH_PRODUCTS_SUCCESS',
    FETCH_PRODUCTS_FAILURE: 'FETCH_PRODUCTS_FAILURE'
};

export default CartConstants;